import { j as r } from "../../modules/index.es3.js";
import { Command as o } from "../../modules/index.es40.js";
import * as m from "react";
import { cn as t } from "../../utils/styling.es.js";
import { Dialog as p, DialogContent as l } from "../Dialog/Dialog.es.js";
import c from "../../modules/index.es41.js";
import u from "../Spinner/Spinner.es.js";
const n = m.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  o,
  {
    ref: d,
    className: t(
      "font-body flex h-full w-full flex-col overflow-hidden bg-background text-foreground rounded-md",
      a
    ),
    ...e
  }
));
n.displayName = o.displayName;
const R = ({
  children: a,
  size: e,
  filter: d,
  ...s
}) => /* @__PURE__ */ r.jsx(p, { ...s, children: /* @__PURE__ */ r.jsx(l, { className: "overflow-hidden p-0 shadow-lg", size: e, children: /* @__PURE__ */ r.jsx(
  n,
  {
    filter: d,
    className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-foreground/50 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
    children: a
  }
) }) }), f = m.forwardRef(({ className: a, disableSearch: e, loading: d = !1, ...s }, i) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    className: t(
      "flex items-center border-b px-3 group focus-within:border-primary",
      e && "focus-within:border-0 h-0 border-none",
      a
    ),
    "cmdk-input-wrapper": "",
    children: [
      !e && /* @__PURE__ */ r.jsx(c, { className: "mr-2 h-4 w-4 shrink-0 opacity-50 group-focus-within:text-primary" }),
      /* @__PURE__ */ r.jsx(
        o.Input,
        {
          ref: i,
          className: t(
            "flex h-10 w-full border-0 bg-transparent py-3 text-base outline-none placeholder:text-foreground/50 disabled:cursor-not-allowed disabled:opacity-50 focus:ring-0",
            e && "text-[0px] h-0"
          ),
          ...s
        }
      ),
      d && /* @__PURE__ */ r.jsx(u, { size: "xs", appearance: "primary", className: "-mr-1" })
    ]
  }
));
f.displayName = o.Input.displayName;
const x = m.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  o.List,
  {
    ref: d,
    className: t("overflow-y-auto overflow-x-hidden", a),
    ...e
  }
));
x.displayName = o.List.displayName;
const g = m.forwardRef((a, e) => /* @__PURE__ */ r.jsx(
  o.Empty,
  {
    ref: e,
    className: "py-4 text-center text-sm font-medium",
    ...a
  }
));
g.displayName = o.Empty.displayName;
const y = m.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  o.Group,
  {
    ref: d,
    className: t(
      "overflow-hidden text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-3 [&_[cmdk-group-heading]]:text-sm [&_[cmdk-group-heading]]:font-semibold [&_[cmdk-group-heading]]:text-foreground",
      a
    ),
    ...e
  }
));
y.displayName = o.Group.displayName;
const h = m.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  o.Separator,
  {
    ref: d,
    className: t("-mx-1 h-px bg-foreground/10", a),
    ...e
  }
));
h.displayName = o.Separator.displayName;
const w = m.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  o.Item,
  {
    ref: d,
    className: t(
      "relative flex cursor-default select-none items-center rounded px-2 py-1.5 text-sm outline-none aria-selected:rounded-sm aria-selected:bg-primary-50/50 aria-selected:text-primary data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:aria-selected:bg-black",
      a
    ),
    ...e
  }
));
w.displayName = o.Item.displayName;
const N = ({
  className: a,
  ...e
}) => /* @__PURE__ */ r.jsx(
  "span",
  {
    className: t(
      "ml-auto text-xs tracking-widest text-foreground/70",
      a
    ),
    ...e
  }
);
N.displayName = "CommandShortcut";
const I = o.Loading;
export {
  n as Command,
  R as CommandDialog,
  g as CommandEmpty,
  y as CommandGroup,
  f as CommandInput,
  w as CommandItem,
  x as CommandList,
  I as CommandLoading,
  h as CommandSeparator,
  N as CommandShortcut
};
//# sourceMappingURL=Command.es.js.map
